import request from '@/utils/request'

export function createLive(data) {
    return request({
        url: `api/agora/createChannel`,
        method: 'post',
        data
    })
}


export function joinLive(data) {
    return request({
        url: `api/agora/joinChannel`,
        method: 'post',
        data
    })
}


export function getListLivestream(data) {
    return request({
        url: `api/livestream/getListLivestream?current=${data.current}&size=${data.size}`,
        method: 'post',
    })
}

export function getLiveStreamById(data) {
    return request({
        url: `api/livestream/getLiveStreamById?roomId=${data.roomId}&_t=${Date.now()}`,
        method: 'get',
    })
}

export function changeLiveStatus(data) {
    return request({
        url: `api/livestream/changeLiveStatus`,
        method: 'post',
        data
    })
}


export function getTeacherByUserId(data) {
    return request({
        url: `api/livestream/getTeacherByUserId?userUuid=${data.userUuid}`,
        method: 'get',
    })
}

export function joinChannel(data) {
    return request({
        url: `api/livestream/joinChannel`,
        method: 'post',
        data
    })
}

export function getTeacherChannel(data) {
    if (data.liveStatus !== undefined) {
        return request({
            url: `api/livestream/getTeacherChannel?current=${data.current}&size=${data.size}&userUuid=${data.userUuid}&liveStatus=${data.liveStatus}`,
            method: 'get',
        })
    } else {
        return request({
            url: `api/livestream/getTeacherChannel?current=${data.current}&size=${data.size}&userUuid=${data.userUuid}`,
            method: 'get',
        })
    }
}

// 视频回放
export function getListLiveReplay(data) {
    return request({
        url: `/api/livereplay/getListLiveReplay?current=${data.current}&size=${data.size}`,
        method: 'post',
    })
}

export function getLiveLiveReplayById(data) {
    return request({
        url: `api/livereplay/getLiveLiveReplayById?roomUuid=${data.roomId}`,
        method: 'get',
    })
}

// 更多直播列表
// export function getLiveslist(current, size, industryType, specialId, userName, roomUuid, roomType, roomStatus, livesteramEndTime, livesteramTime, roomName, liveStatus
// ) {
//     return request({
//         url: `api/livestream/liveslist`,
//         method: 'get',
//         params: {
//             'current': current,
//             'size': size,
//             'industryType': industryType,
//             'specialId': specialId,
//             'userName': userName,
//             'roomUuid': roomUuid,
//             'roomType': roomType,
//             'roomStatus': roomStatus,
//             'livesteramEndTime': livesteramEndTime,
//             'livesteramTime': livesteramTime,
//             'roomName': roomName,
//             'liveStatus': liveStatus,
//         }
//     })
// }
export function getLiveslist(params = {}) {
    // 过滤掉 null/undefined/空字符串的参数
    const filteredParams = Object.fromEntries(
        Object.entries(params).filter(([_, value]) => value !== null && value !== undefined && value !== '')
    );

    return request({
        url: `api/livestream/liveslist`,
        method: 'get',
        params: filteredParams
    });
}
